<!-- vue\public\index.html に App.vue が差し込まれる -->
<template>
  <HeaderArea class="header-height"></HeaderArea>
  <ContentsArea class="contents-height"></ContentsArea>
</template>

<script>
import HeaderArea from '@/components/HeaderArea.vue'
import ContentsArea from '@/views/ContentsArea.vue'

export default {
  name: 'App',
  components: {
    HeaderArea,
    ContentsArea,
  }
}
</script>

<style>
html {
  overflow: hidden !important;
}

/* フィールドセット */
fieldset {
  height: fit-content;
  margin: 10px 15px 0px 15px;
  background: white;
}

fieldset:last-child {
  margin-bottom: 10px;
}

fieldset>legend {
  background-color: #006CB6;
  color: white;
  margin-left: 15px;
  padding: 10px;
}

fieldset>div {
  margin-left: 10px;
  padding: 10px;
}

/* スクロールバー */
.scroll-bar {
  overflow-y: scroll;
  scrollbar-width: thin;
}

.scroll-bar:hover {
  overflow-y: scroll;
  scrollbar-width: thin;
}

/* フォーム */
input {
  margin-bottom: 8px;
}

.input-text {
  width: 95%;
  margin-left: 15px;
}

.form-warn {
  background-color: #ffc5c5;
  margin-right: 12px;
}

.form-area {
  margin-right: 12px;
  margin-bottom: 4px;
  background-color: white;
}

input,
select {
  background-color: white !important;
  border-style: solid !important;
  border-radius: 5px !important;
  padding-left: 10px;
  padding-right: 10px;
}

.input-checkbox,
.input-radio {
  position: relative;
  top: 1px;
  margin-right: 4px;
}

.input-date {
  margin-left: 15px;
}

/* その他 */
.click-cursor {
  cursor: grab;
}

.click-cursor:hover {
  text-decoration: underline;
}

.warn-color {
  color: red;
}
</style>

<style scoped>
.header-height {
  height: 5vh;
}

.contents-height {
  height: 95vh;
}
</style>